import { Component, Output, EventEmitter, Input, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { notNil, States } from "@qqcw/qqsystem-util";

import { Account, Region } from "src/app/core/services/myqq";

@Component({
  selector: "myqq-choose-account-location",
  templateUrl: "./choose-account-location.component.html",
  styleUrls: ["./choose-account-location.component.scss"],
})
export class ChooseAccountLocationComponent implements OnInit {
  @Input()
  regions: Region[] = [];
  @Input()
  pendingAccount?: Account;

  @Output()
  saveProfile = new EventEmitter<Account>();
  @Output()
  back = new EventEmitter();

  constructor(private fb: FormBuilder) {}

  readonly locationForm = this.fb.group({
    state: ["", Validators.required],
    region: ["", Validators.required],
  });

  readonly states = States;
  relevantStates: typeof States = [];
  filterRegions: Region[] = [];

  ngOnInit() {
    // Filter all states to only those with regions
    this.relevantStates = this.states.filter(({ abbreviation }) =>
      this.regions.some(({ state }) => state === abbreviation)
    );
    // Set state in location form if account has a state.
    if (
      notNil(this.pendingAccount?.state) &&
      this.relevantStates
        .map(({ abbreviation }) => abbreviation)
        .includes(this.pendingAccount.state)
    ) {
      this.locationForm.patchValue({ state: this.pendingAccount.state });
      this.changeState(this.pendingAccount.state);
    }
  }

  confirm({ region }: Partial<{ region: string }>) {
    this.saveProfile.emit({
      ...this.pendingAccount,
      regionId: region,
    });
  }

  changeState(state) {
    this.filterRegions = this.regions.filter((r) => r.state === state);
  }

  cancel() {
    this.back.emit();
  }
}
